import React from 'react';

const Section = ({ children }) => {
  return (
    <section className="relative h-full lg:max-h-[800px]">{children}</section>
  );
};

export default Section;
